import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { useIsRestorationProject } from '@/pages/shared/projects/pages/project/pages/conservation/restoration/hooks/useIsRestorationProject';
import { LandMonitoringPageWrapper } from '@/pages/shared/projects/pages/project/pages/sustainableProduction/components/LandMonitoring.page-wrapper';

import { NdviCard } from './components/ndvi/NDVICard';

export const NDVIDetailPage = () => {
  const { t } = useTranslation();
  const isRestorationProject = useIsRestorationProject();

  if (!isRestorationProject) {
    throw new Error('The NDVI page is only accesible for restoration projects');
  }

  return (
    <LandMonitoringPageWrapper title={t('shared.ncaDetail.details.landMonitoring.ndvi.title')}>
      <Stack spacing={8}>
        <NdviCard />
      </Stack>
    </LandMonitoringPageWrapper>
  );
};
